import { Box, Flex, Text } from "@chakra-ui/react";
import { useJournalistContext } from "@root/context/journalist-context";
import { useTranslation } from "react-i18next";
import { JOURNALIST_STATUS, USER_TYPES } from "@root/constants";
import React, { useEffect, useMemo, useState } from "react";
import {
  PendingIcon,
  JournalistIcon,
  CertificateIcon,
} from "@root/assets/icons";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";

const cardBg = "white";
const cardBorder = "1px solid #E4EBF0";
const cardRadius = "16px";

export const StatsCards = () => {
  const { journalists, fetchSubscriberStats, subscriberStats } =
    useJournalistContext();
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  const { t } = useTranslation("common");

  useEffect(() => {
    fetchSubscriberStats();
  }, []);
  console.log("subscriberStats", subscriberStats);

  // Determine the list of journalist objects (array)
  const journalistList = journalists?.rows || journalists || [];
  const isNonSubscriber = isLoggedInUser?.role === USER_TYPES.NON_SUBSCRIBER;

  const stats = useMemo(() => {
    const allStats = [
      {
        label: t("stats.pendingApprovals"),
        // Count pending approvals from all journalists
        value: subscriberStats?.pendingRequestCount,
        bgColor: "#3A59D11F",
        icon: <PendingIcon />,
      },
      {
        label: t("stats.totalJournalist"),
        value: subscriberStats?.journalistCount,
        bgColor: "#CBE9571A",
        icon: <JournalistIcon />,
      },
      {
        label: t("stats.certificatesIssued"),
        value: subscriberStats?.certificateIssuedCount,
        bgColor: "#FFB4331A",
        icon: <CertificateIcon />,
      },
    ];

    // Filter out pending approvals card for non-subscribers
    if (isNonSubscriber) {
      return allStats.filter(
        (stat) => stat.label !== t("stats.pendingApprovals"),
      );
    }

    return allStats;
  }, [journalistList, t, subscriberStats, isNonSubscriber]);

  return (
    <Flex
      gap={4}
      mb={6}
      flexWrap={{ base: "wrap", md: "nowrap" }}
      data-tour-item="pledge-dashboard-stats"
    >
      {stats.map((stat, idx) => (
        <Box
          key={stat.label}
          flex="1"
          bg={cardBg}
          border={cardBorder}
          borderRadius={cardRadius}
          p={6}
          minW="200px"
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          boxShadow="sm"
        >
          <Flex
            width={"100%"}
            display={"flex"}
            justifyContent={"space-between"}
            align="center"
            gap={2}
            mb={2}
          >
            <Text fontSize="lg" fontWeight="500">
              {stat.label}
            </Text>
            <Box bgColor={stat.bgColor} borderRadius={"50%"} padding={2}>
              {stat.icon}
            </Box>
          </Flex>
          <Text fontSize="3xl" fontWeight="bold" color="blue">
            {stat.value}
          </Text>
        </Box>
      ))}
    </Flex>
  );
};
